import {Component, Inject, OnInit} from '@angular/core';
import {Test} from '../../../data/models/test/test';
import {TestService} from '../../../services/api/test.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-test-delete-dialog',
  templateUrl: './test-delete-dialog.component.html',
  styleUrls: ['./test-delete-dialog.component.css']
})
export class TestDeleteDialogComponent implements OnInit {

  test: Test;

  constructor(
    private testService: TestService,
    private dialogRef: MatDialogRef<TestDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      test: Test,
    },
  ) {
    this.test = data.test;
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
    this.testService.deleteTest(this.test.id)
      .then(() => this.dialogRef.close(true));
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
